<template>
  <form>
    <button type="button" class="btn btn-primary btn-sm mr-1" @click="exportData(false)">
      <i class="fas fa-file-export" />
      Export
    </button>
    <button type="button" class="btn btn-primary btn-sm mr-1" v-if="exportToCAShown" @click="exportData(true)">
      <i class="fas fa-file-export" />
      Export to CA
    </button>
    <button
      class="btn btn-primary btn-sm mx-1"
      type="button"
      @click="() => {this.options.fileImport.is_active = !this.options.fileImport.is_active}"
    >
      <i class="fas fa-file-import" />
      Import
    </button>
    <template v-if="options.fileImport.is_active">
      <div class="custom-file col-6 ml-1">
        <input
          id="fileImport"
          name="file"
          class="custom-file-input"
          type="file"
          @change="upload($event)"
        />
        <label
          class="custom-file-label form-control-sm"
          for="fileImport"
        >Choose file (Click Import button again to cancel)</label>
      </div>
    </template>
    <button v-if="exportToShopify" v-for="domain in this.$props.domains" :key="domain.id"
      class="btn btn-primary btn-sm mx-1"
      type="button"
      @click="shopifySync($event,domain.id)"
    >
      <i class="fas fa-file-import" />
      Sync Shopify-{{ domain.name }}
    </button>
  </form>
</template>

<script>
import FileImportRequest from "@/components/ApiRequester/Import";
import FileExportRequest from "@/components/ApiRequester/Export";
import ShopifySyncRequest from "@/components/ApiRequester/ShopifySync";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    filter: {
      type: String,
      required: true,
    },
    exportToCAShown: {
      type: Boolean,
      required: false,
      default: () => false
    },
    exportToShopify: {
      type: Boolean,
      required: false,
      default: () => false
    },
    domains: {
      type: Array,
      required: false,
      default: () => [{'id':1,'name':'Maxtop'}]
    }
  },
  data: () => ({
    options: {
      fileImport: {
        is_active: false,
        file: null,
      },
      shopifySync: {
        is_active: false,
        file: null,
      },      
      export: {},
    },
  }),
  methods: {
    exportData(exportToCA) {
      document.getElementById('loader').classList.add('active');

      const ApiRequester = new FileExportRequest(this.$props.url);
      ApiRequester.get({
        filter: this.$props.filter
      }, exportToCA).then((response) => {
        const blob = new Blob([response.data], {type:'application/*'})
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)

        let title = this.$props.title
        if (exportToCA) {
          title += '-CA'
        }

        link.download = title + '-' + Date.now() + '.xlsx';
        document.getElementById('loader').classList.remove('active');
        link.click();
      }).catch((error) => {
        const blob = new Blob([error.response.data], {type : "application/json"})
        const reader = new FileReader()

        reader.onload = (args) => {
          this.$emit('export', JSON.parse(args.currentTarget.result).error)
        }
        document.getElementById('loader').classList.remove('active');
        reader.readAsText(blob);
      });
    },
    upload(evt) {
      const { name, files } = evt.target;
      const payload = new FormData();

      payload.append(name, files[0], files[0].name);

      document.getElementById('loader').classList.add('active');

      const ApiRequester = new FileImportRequest(this.$props.url);
      ApiRequester.store(payload).then((response) => {
        this.options.import.is_active = false;
        this.$emit('import', response.data);
      });
    },
    shopifySync(evt, domainId) {
      document.getElementById('loader').classList.add('active');
      const ApiRequester = new ShopifySyncRequest(this.$props.url, domainId);

//      const { name, files } = evt.target;
      const payload = new FormData();
      payload.append('domainId',domainId);

      ApiRequester.store(payload).then((response) => {
        this.options.shopifySync.is_active = false;
        this.$emit('ShopifySync', response.data);
        document.getElementById('loader').classList.remove('active');
      });

    },
  },
};
</script>